/***
*
*   useDashboard hooks
*   Fetch dashboard metrics, alerts, and activity data
*
**********/

import { useState, useEffect, useCallback } from 'react';
import Axios from 'axios';
import { useAPI } from 'components/lib';

export function useDashboardMetrics(filters = {}) {
  const queryParams = new URLSearchParams();
  if (filters.plan) queryParams.append('plan', filters.plan);
  if (filters.status) queryParams.append('status', filters.status);

  const queryString = queryParams.toString();
  const url = `/api/dashboard/overview${queryString ? `?${queryString}` : ''}`;

  const response = useAPI(url);

  return {
    data: response?.data || null,
    loading: response.loading,
    error: response.error
  };
}

export function useDashboardAlerts(filters = {}) {
  const queryParams = new URLSearchParams();
  if (filters.type) queryParams.append('type', filters.type);
  if (filters.severity) queryParams.append('severity', filters.severity);
  if (filters.page) queryParams.append('page', filters.page);
  if (filters.limit) queryParams.append('limit', filters.limit);

  const queryString = queryParams.toString();
  const url = `/api/dashboard/alerts${queryString ? `?${queryString}` : ''}`;

  const response = useAPI(url);

  return {
    data: response?.data || null,
    loading: response.loading,
    error: response.error
  };
}

export function useSignupFeedback(page = 1, limit = 50) {
  const url = `/api/dashboard/signup-feedback?page=${page}&limit=${limit}`;
  const response = useAPI(url);

  return {
    data: response?.data || null,
    loading: response.loading,
    error: response.error
  };
}

export function useSignupPromotionalData(filters = {}) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const [reload, setReload] = useState(0);

  const fetchData = useCallback(async () => {
    setState(prev => ({ ...prev, loading: true }));
    try {
      const params = new URLSearchParams();
      if (filters.page) params.append('page', filters.page);
      if (filters.limit) params.append('limit', filters.limit);
      if (filters.company_size) params.append('company_size', filters.company_size);
      if (filters.company_type) params.append('company_type', filters.company_type);
      if (filters.search) params.append('search', filters.search);

      const response = await Axios.get(`/api/dashboard/signup-promotional-data?${params.toString()}`);
      setState({ data: response.data.data, loading: false, error: null });
    } catch (err) {
      setState({ data: null, loading: false, error: err.message });
    }
  }, [filters.page, filters.limit, filters.company_size, filters.company_type, filters.search]);

  useEffect(() => {
    fetchData();
  }, [fetchData, reload]);

  return { ...state, refetch: () => setReload(r => r + 1) };
}